(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[999],{

/***/ 80999:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LayoutWidget082": function() { return /* binding */ LayoutWidget082; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var features_translations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91929);
/* harmony import */ var features_widgets__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68642);
/* harmony import */ var features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52853);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47696);
/* harmony import */ var shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65202);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63414);
/* harmony import */ var _LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45665);
/* harmony import */ var _LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10__);











var LayoutWidget082 = function(param) {
    var payload = param.payload;
    var t = (0,features_translations__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    var ref;
    var next_news = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var instanceId = (0,features_widgets__WEBPACK_IMPORTED_MODULE_2__/* .buildWidgetInstanceId */ .G1)("l082", payload.id, features_widgets_widgets_config__WEBPACK_IMPORTED_MODULE_3__/* .WIDGETS_REGISTRY["LAYOUT-WIDGET"] */ .R["LAYOUT-WIDGET"]);
    var articles = (0,shared_contexts_PageData__WEBPACK_IMPORTED_MODULE_7__/* .useCollectedData */ .M)(instanceId, [
        {
            name: "articles",
            defaultValue: []
        }, 
    ]).articles;
    var _articles = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(articles, 1), article = _articles[0];
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)().locale;
    var articleDate = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(function() {
        return (0,shared_utils__WEBPACK_IMPORTED_MODULE_8__/* .formatDate */ .p6)(article === null || article === void 0 ? void 0 : article.date, locale);
    }, [
        article === null || article === void 0 ? void 0 : article.date,
        locale
    ]);
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Container */ .W2, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .PageLink */ .H_, {
                directory: "news",
                slug: article === null || article === void 0 ? void 0 : article.slug,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().block),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .ImageLite */ .NH, {
                            image: article === null || article === void 0 ? void 0 : article.previewImage,
                            className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().image)
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().content),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                    color: "light",
                                    appearance: "bigger",
                                    children: t(next_news)
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().text),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .nv, {
                                            className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().date),
                                            color: "light",
                                            children: articleDate
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().title),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading4 */ .k8, {
                                                    color: "light",
                                                    children: article.title
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().circle),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().arrow),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_6__/* .Icon */ .JO, {
                                                            className: (_LayoutWidget082_module_scss__WEBPACK_IMPORTED_MODULE_10___default().icon),
                                                            name: "arrow_right"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (LayoutWidget082);


/***/ }),

/***/ 45665:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LayoutWidget082_wrapper__sDrmr","block":"LayoutWidget082_block__hEXLK","image":"LayoutWidget082_image__cKgWX","content":"LayoutWidget082_content__aw0N1","title":"LayoutWidget082_title__qFJAU","date":"LayoutWidget082_date__6yvXI","circle":"LayoutWidget082_circle__9TCro","arrow":"LayoutWidget082_arrow__uLumw"};

/***/ })

}]);